module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_4.770a4bcd.png";